module.exports = __webpack_public_path__ + "static/media/8.04f36f4c.jpeg";